const InboxIcon = () => {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6192 3C15.6622 3 16.6656 3.41222 17.4037 4.15189C18.1426 4.89 18.5556 5.88556 18.5556 6.92778V13.0722C18.5556 15.2422 16.79 17 14.6192 17H6.93556C4.76478 17 3 15.2422 3 13.0722V6.92778C3 4.75778 4.757 3 6.93556 3H14.6192ZM15.8566 8.08669L15.9188 8.02446C16.1047 7.79891 16.1047 7.47224 15.9103 7.24669C15.8022 7.1308 15.6536 7.06002 15.4988 7.04446C15.3355 7.03591 15.1799 7.09113 15.0625 7.20002L11.5555 10C11.1044 10.3741 10.4581 10.3741 9.99995 10L6.49995 7.20002C6.25806 7.02113 5.92361 7.04446 5.72217 7.25446C5.51217 7.46446 5.48883 7.79891 5.66695 8.03224L5.76883 8.13335L9.30772 10.8945C9.74328 11.2367 10.2714 11.4234 10.8244 11.4234C11.3758 11.4234 11.9133 11.2367 12.3481 10.8945L15.8566 8.08669Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default InboxIcon;
